import { render, staticRenderFns } from "./PauseBlock.vue?vue&type=template&id=3e63c749&"
import script from "./PauseBlock.vue?vue&type=script&lang=js&"
export * from "./PauseBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports